import React from 'react';

function NotFound(){
    return (
        <React.Fragment>
            <div className="Contact">
                    <div className="Page">
                    <h1>Error 404</h1>
                    
                    </div>
            </div>
        </React.Fragment>
       
  );
}

export default NotFound;